import { RestApiResponse } from '../../common/rest-api.response';

import { UserLoginInfo } from './user-login-info';

interface UserLoginResponseConstruction extends RestApiResponse {
    userLoginInfo?: Partial<UserLoginInfo>;
}

export class UserLoginResponse extends RestApiResponse {
    public userLoginInfo: UserLoginInfo;

    constructor(data?: UserLoginResponseConstruction) {
        super(data);
        this.userLoginInfo = data?.userLoginInfo ? new UserLoginInfo(data.userLoginInfo) : undefined;
    }
}
